import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';

export function updateLoadSheet(id: number, templateData: FormData) {
  return {
    type: 'UPDATE_LOAD_SHEET',
    payload: axios.patch(`${getNonGwApiRoot()}/distribution/load_sheets/${id}`, templateData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  };
}
